import { BaseManagementBloc } from "./bloc.base";

export class BoxManagementBloc extends BaseManagementBloc {
}

